var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 8a2 2 0 012-2h10a2 2 0 012 2v.25h1A2.75 2.75 0 0122 11v2a2.75 2.75 0 01-2.75 2.75h-1V17a5 5 0 01-5 5h-4a5 5 0 01-5-5V8zm12-.5h-10a.5.5 0 00-.5.5v9a3.5 3.5 0 003.5 3.5h4a3.5 3.5 0 003.5-3.5V8a.5.5 0 00-.5-.5zm3 2.25h-1v4.5h1c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25zM8.25 5a.75.75 0 01-.75-.75v-1a.75.75 0 011.5 0v1a.75.75 0 01-.75.75zm3 0a.75.75 0 01-.75-.75v-2.5a.75.75 0 011.5 0v2.5a.75.75 0 01-.75.75zm3 0a.75.75 0 01-.75-.75v-1a.75.75 0 011.5 0v1a.75.75 0 01-.75.75z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/Coffee.22bdf4cd376bfee6323365db3beee382.svg";
export { ForwardRef as ReactComponent };